module.exports = __webpack_public_path__ + "img/btn_power2_n.a986aa25.png";